import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getDeltaHedgeAccountsTable } from "../../../Requests/deltaHedgeAccounts";
import { IDeltaHedgeAccountSearchParam } from "../../../Interfaces/deltaHedgeAccounts";
import { Additional } from "./Additional";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import { useEffect } from "react";
import { setDeltaHedgeAccountFlag } from "../../../Features/DeltaHedgeAccounts/deltaHedgeAccountsSlice";

interface IProps {
  searchParams: IDeltaHedgeAccountSearchParam;
}

const DeltaHedgeAccountTable = ({ searchParams }: IProps) => {
  const refreshFlag = useAppSelector(
    (store) => store.deltaHedgeAccountsSlice.accountTableRefetchFlag
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (refreshFlag) dispatch(setDeltaHedgeAccountFlag(false));
  }, [refreshFlag]);

  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          AdditionalBody={Additional}
          onAction={onAction}
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getDeltaHedgeAccountsTable}
      searchParameters={searchParams}
    />
  );
};

export default DeltaHedgeAccountTable;
